<template>
  <!-- id="SelectCity" -->
  <b-modal
    v-model="onChangeCityModalModal"
    :id="getModals.cityModalModalId"
    :ref="getModals.cityModalModalId"
    size="xl"
    title="Select City"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    :hide-header-close="true"
  >
    <div>
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row my-4">
            <div class="col-12 mx-auto text-center mb-3">
              <div class="search-city-input">
                <img src="@/assets/img/icons/search.svg" alt="search" />
                <input
                  type="search"
                  placeholder="Search city"
                  class="pl-5 form-control"
                  v-model="searched_city"
                  @input="filterCities"
                />
              </div>
              <div v-if="showDropdown && filteredCities.length > 0">
                <ul aria-labelledby="dropdownMenuButton">
                  <li
                    v-for="(city, index) in filteredCities"
                    :key="index"
                    class="l-none"
                    style="cursor: pointer"
                  >
                  <div :class="selectSearchedCity ? 'd-block' : 'd-none'">
                    <a 
                      @click="
                        selectSearchedCity(city);
                        selected = city;
                        searched_city = city.city_name;
                        setCityAndCoutry(selected);
                        setCity(selected);
                        onHandleCloseModal('cityModalModal');
                      "
                    >
                      {{ city.city_name }}
                    </a>
                  </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-12 my-4 city-search-box">
              <!-- <component-content-loader v-if="isCityLoading" /> -->
              <div>
                <div
                  v-if="!isCityLoading && locations && locations.length > 0"
                  class="all-state-list"
                >
                  <div v-for="(data, index) in mainCities" :key="index">
                    <div
                      class="city-icon"
                      @click="
                        () => {
                          selected = data;
                          searched_city = data.city_name;
                          setCityAndCoutry(selected);
                          setCity(selected);
                          onHandleCloseModal('cityModalModal');
                        }
                      "
                    >
                      <img
                        :src="
                          require('@/assets/img/city/' +
                            data.city_name +
                            '.png')
                        "
                        class="img-fluid"
                        alt
                      />

                      <p class="state mb-2 text-rose-gold">
                        {{ data.city_name }}
                      </p>
                    </div>
                  </div>
                  <!-- <div
                    v-for="(StateItem, StateIndex) in locations"
                    :key="StateIndex + '_State'"
                  > -->
                  <!-- <div class="city-icon">
                      <img
                        src="@/assets/img/city/Ahmedabad.png"
                        class="img-fluid"
                        alt
                      />
                    </div>
                    <p class="state mb-2 text-rose-gold">
                      {{ StateItem.States[0].state_name }}
                    </p> -->

                  <!-- <div
                      class="city-list"
                      :class="
                        showCity && StateIndex == '0' ? 'd-flex' : 'd-none'
                      "
                    >
                      <p
                        class="city mb-2"
                        v-for="(CityItem, CityIndex) in StateItem.States"
                        :key="CityIndex + '_' + CityItem.city_name"
                        @click="
                          () => {
                            selected = CityItem;
                            searched_city = CityItem.city_name;
                            setCityAndCoutry(selected);
                            onHandleCloseModal('cityModalModal');
                          }
                        "
                      >
                        {{ CityItem.city_name }}
                      </p>
                    </div> -->
                  <!-- <div
                      class="spacer"
                      :class="
                        showCity && StateIndex == '0' ? 'd-block' : 'd-none'
                      "
                    ></div> -->
                  <!-- </div> -->
                </div>
              </div>
              <div class="mt-3">
                <p
                  @click="toggleCityList"
                  class="text-rose-gold text-center"
                  style="cursor: pointer"
                >
                  View All Cities
                </p>
                <div :class="showCity ? 'd-block' : 'd-none'">
                  <div class="all-city-list mt-4">
                    <div
                      v-for="(data, index) in cityList"
                      :key="index"
                      @click="
                        () => {
                          selected = data;
                          searched_city = data.city_name;
                          setCityAndCoutry(selected);
                          setCity(selected);
                          onHandleCloseModal('cityModalModal');
                        }
                      "
                    >
                      {{ data.city_name }}
                    </div>

                    <!-- <span v-for="(data, index) in cityList" :key="index">
                      {{ data.city_name }}
                    </span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="d-none city-search-box">
              <div
                class="row mx-0"
                v-if="!isCityLoading && locations && locations.length > 0"
              >
                <div
                  class="col-6 col-md-4 col-lg-3 aaa px-2 mb-2"
                  v-for="(StateItem, StateIndex) in locations"
                  :key="StateIndex + '_State'"
                >
                  <p class="state mb-2 text-rose-gold">
                    {{ StateItem.States[0].state_name }}
                  </p>
                  <p
                    class="city mb-2"
                    v-for="(CityItem, CityIndex) in StateItem.States"
                    :key="CityIndex + '_' + CityItem.city_name"
                    @click="
                      () => {
                        selected = CityItem;
                        searched_city = CityItem.city_name;
                        setCityAndCoutry(selected);
                        setCity(selected);
                        onHandleCloseModal('cityModalModal');
                      }
                    "
                  >
                    {{ CityItem.city_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";
import LocationService from "@/apiServices/LocationService";

export default {
  data() {
    return {
      selected: null,
      locations: [],
      cityList: [],
      showCity: false,
      searched_city: null,
      isCityLoading: false,
      mainCities: [
        "Mumbai",
        "Delhi NCR",
        "Hyderabad",
        "Kolkata",
        "Ahmedabad",
        "Jaipur",
      ],
      filteredCities: [],
      showDropdown: false,
    };
  },
  computed: {
    onChangeCityModalModal: {
      get() {
        return this.getModals.cityModalModal;
      },
      set(value) {
        !value ? this.onHandleCloseModal("cityModalModal") : undefined;
      },
    },
    ...mapGetters([
      // Modal
      "getModals",
      "getLocation",
    ]),
  },
  beforeMount() {
    this.getLocations();
    this.getCityList();
    this.showCity = false;
  },
  methods: {
    ...mapActions([
      "onHandleOpenModal",
      "onHandleCloseModal",
      "setCityAndCoutry",
    ]),
    setCity(selected) {
      localStorage.setItem("city_id", selected.city_id);
      this.$router.push({ name: 'Home Page' });
      
    },

    async filterCities() {
      console.log("jheel:", this.searched_city);
      if (!this.searched_city) {
        this.filteredCities = [];
        this.showDropdown = false;
        return;
      }
      // Filter cities based on user input
      this.filteredCities = this.cityList.filter((city) =>
        city.city_name.toLowerCase().includes(this.searched_city.toLowerCase())
      );
      console.log("Mayur:", this.filteredCities);
      this.showDropdown = true; // Show dropdown
    },

    async getLocations() {
      let loader = Vue.$loading.show();
      this.isCityLoading = true;

      try {
        let search = this.searched_city ? this.searched_city : null;
        const response = await LocationService.GetLocations({ search });
        const { data } = response;
        if (data && data.status) {
          this.locations = data.data;
        }
        return null;
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
        setTimeout(() => (this.isCityLoading = false), 500);
      }
    },

    // getMainCities() {},
    // async getLocations(e) {
    //   let loader = Vue.$loading.show();
    //   this.isCityLoading = true;

    //   try {
    //     let search = this.searched_city ? this.searched_city : null;
    //     const response = await LocationService.GetLocations({ search });
    //     const { data } = response;
    //     if (data && data.status) {
    //       this.locations = data.data;
    //     }
    //     return null;
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     loader.hide();
    //     setTimeout(() => (this.isCityLoading = false), 500);
    //   }
    // },
    async getCityList() {
      const response = await LocationService.GetCities();
      const { data } = response;
      this.cityList = data.data.sort((a, b) => {
        return a.city_name < b.city_name ? -1 : a > b ? 1 : 0;
      });
      let premiumCities = [];
      this.mainCities.map((city_name) => {
        this.cityList.map((cityData) => {
          if (cityData.city_name == city_name) {
            premiumCities.push(cityData);
          }
        });
      });

      this.mainCities = premiumCities;
    },
    toggleCityList() {
      this.showCity = !this.showCity;
    },

    async selectSearchedCity(city) {
      this.searched_city = city.city_name;
      this.filteredCities = []; // Clear filtered cities after selection
      this.showDropdown = false; // Hide dropdown after selection
      this.selected = city;
      this.setCity(city); // Set selected city
      this.onHandleCloseModal("cityModalModal");
    },
  },
};
</script>

<style>
.l-none {
  list-style-type: none;
  text-align: left;
}
.all-state-list {
  display: grid;
  grid-template-columns: repeat(6, 15%);
  gap: 10px 0;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1200px) {
  .all-city-list {
    display: grid;
    grid-template-columns: repeat(6, 15%);
    gap: 10px 0;
    justify-content: center;
    align-items: center;
    grid-auto-flow: column;
    grid-template-rows: repeat(8, 1fr);
  }
}

.all-city-list > div {
  cursor: pointer;
}
.all-state-list {
  /* grid-template-columns: repeat(10, 10%); */
  text-align: center;
}
.city-icon {
  width: 50%;
  margin: auto;
  cursor: pointer;
}
.city {
  cursor: pointer;
}
.city-list,
.state-list {
  display: flex;
  gap: 0 20px;
  flex-wrap: wrap;
}
.city-list {
  position: absolute;
}

.search-city-input {
  position: relative;
}
.search-city-input img {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.city-search-box p {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
}
.city-search-box .state {
  color: #bf836c;
  text-align: center;
  padding-top: 12px;
}
.city-search-box .city {
  /* color: #595858; */
}
.city-search-box .city:hover,
.city-search-box .city:active,
.city-search-box .city.active {
  color: #007bff;
}
.aaa {
  display: inline-block;
  float: none;
}
.spacer {
  margin-bottom: 90px;
}

/* *** */

.bn_cols {
  -moz-column-count: 4;
  -moz-column-gap: 3%;
  -moz-column-width: 30%;
  -webkit-column-count: 4;
  -webkit-column-gap: 3%;
  -webkit-column-width: 30%;
  column-count: 4;
  column-gap: 3%;
  column-width: 30%;
}
.city-display {
  display: none;
}

.city-suggestions {
  position: absolute;
  top: calc(100% + 5px); /* Adjust the distance below the input if needed */
  left: 0;
 right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 999; /* Ensure a high enough z-index */
}
.city-suggestions ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.city-suggestions li {
  padding: 8px 12px;
  cursor: pointer;
}
.city-suggestions li:hover {
  background-color: #f0f0f0;
}

@media (max-width: 767px) {
  .all-state-list {
    grid-template-columns: repeat(2, 50%);
  }
  .all-city-list {
    display: grid;
    grid-template-columns: repeat(3, 33%);
    gap: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/selectCity.vue